import { Component, OnInit } from '@angular/core';
import {ApiRestService} from "../_service/api-rest.service";
import {Ruolo} from "../models/Ruolo";
import {ToastrService} from "ngx-toastr";
import {Capacita} from "../models/capacita";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {number} from "ngx-custom-validators/src/app/number/validator";

@Component({
  selector: 'app-ruoli-list',
  templateUrl: './ruoli-list.component.html',
  styleUrls: ['./ruoli-list.component.css']
})
export class RuoliListComponent implements OnInit {
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'capacita',
    searchPlaceholderText: 'Cerca',
    allowSearchFilter: true,
  };
  Lista: Ruolo[];
  Capacita: Capacita[];
  constructor (
    private apirest: ApiRestService,
    private toastService: ToastrService
  ) { }

  ngOnInit(): void {
    this.Refresh();
  }

  Refresh(){
    this.apirest.getRuoliList().subscribe(data=>{
      this.Lista = data.data;
    })
    this.apirest.getCapacita().subscribe(data=>{
      this.Capacita = data.data;
    })
  }

  add() {
    if(!this.Lista)
      this.Lista = [];
    this.Lista.push({modifica: true, id: undefined, label: undefined, capacitaSelezionate: []})
  }

  edit(item: Ruolo) {
    if(item.modifica ){
      if(!item.ruolo || item.ruolo == "")
        this.toastService.warning("inserire un nome", "Attenzione!!");
      else if(!item.capacitaSelezionate || item.capacitaSelezionate.length<=0)
        this.toastService.warning("Selezionare almeno una capacità", "Attenzione!!");
      else {
        item.modifica = !item.modifica;
        item.capacita = this.idlist(item.capacitaSelezionate);
        if(item.id)
          this.apirest.UpdateRuolo(item).subscribe(()=>{
            this.Refresh();
          });
        else
          this.apirest.AddRuolo(item).subscribe(()=>{
            this.Refresh();
          });
      }
    }else {
      this.apirest.getRuolo(item.id).subscribe(data => {
        item.capacitaSelezionate = data.capacita;
        item.modifica = true;
      })
    }

  }

  delete(co: any) {
    if(co.modifica)
      this.Refresh();
    else if(co.id)
      this.apirest.DeleteRuolo(co).subscribe(()=>{
        this.Refresh();
      });
    else {
      const idx: number = this.Lista.findIndex(x => x == co);
      if (idx > -1)
        this.Lista.splice(idx, 1);
    }

  }
  idlist(items :any[]):number[]{
    const out:number[] = [];
    items.forEach(item=> out.push(item.id))
    return out;
  }
}
